import React from 'react';

function AdminDangerZone({ activePool, activeTournament, onClearPool, onDeletePool, onDeletePoolParticipants, onDeleteTournament, onResetGames }) {
    return (
        <div className="space-y-4">
            {(!activePool && !activeTournament) && (
                <div className="bg-gray-900 border border-gray-700 rounded-xl p-4 text-sm text-gray-400">
                    Select a tournament and pool from the dropdowns at the top of the page to enable these actions.
                </div>
            )}
            <div className="bg-gray-900 border border-red-900 rounded-xl p-6">
                <h3 className="text-lg font-black text-red-400 mb-2">Clear pool data</h3>
                <p className="text-gray-400 text-sm mb-4">
                    Removes all picks, game results, and entries from <strong className="text-white">{activePool?.name}</strong>.
                    Pool settings and scoring rules are kept. Use this to reset between seasons.
                </p>
                <button
                    onClick={onClearPool}
                    disabled={!activePool}
                    className="bg-red-900 hover:bg-red-800 disabled:opacity-50 border border-red-700 text-red-300 font-bold px-6 py-2 rounded-lg transition-colors text-sm"
                >
                    Clear pool data
                </button>
            </div>

            <div className="bg-gray-900 border border-red-900 rounded-xl p-6">
                <h3 className="text-lg font-black text-red-400 mb-2">Remove all participants from pool</h3>
                <p className="text-gray-400 text-sm mb-4">
                    Removes all entries and picks from <strong className="text-white">{activePool?.name}</strong>.
                    Participant accounts are kept — they just won't be enrolled in this pool anymore.
                </p>
                <button
                    onClick={onDeletePoolParticipants}
                    disabled={!activePool}
                    className="bg-red-900 hover:bg-red-800 disabled:opacity-50 border border-red-700 text-red-300 font-bold px-6 py-2 rounded-lg transition-colors text-sm"
                >
                    Remove all participants
                </button>
            </div>

            <div className="bg-gray-900 border border-red-900 rounded-xl p-6">
                <h3 className="text-lg font-black text-red-400 mb-2">Delete pool</h3>
                <p className="text-gray-400 text-sm mb-4">
                    Permanently deletes <strong className="text-white">{activePool?.name}</strong> and everything inside it —
                    picks, results, entries, and scoring rules. This cannot be undone.
                </p>
                <button
                    onClick={onDeletePool}
                    disabled={!activePool}
                    className="bg-red-700 hover:bg-red-600 disabled:opacity-50 text-white font-bold px-6 py-2 rounded-lg transition-colors text-sm"
                >
                    Delete pool permanently
                </button>
            </div>

            <div className="bg-gray-900 border border-red-900 rounded-xl p-6">
                <h3 className="text-lg font-black text-red-400 mb-2">Reset games</h3>
                <p className="text-gray-400 text-sm mb-4">
                    Deletes all games for <strong className="text-white">{activeTournament?.name}</strong> and
                    re-runs Initialize in one step. Rounds, seeds, pools, and participants are untouched.
                    This is the recovery path for a broken or partial game structure.
                </p>
                <p className="text-yellow-600 text-xs mb-4">
                    ⚠ Will refuse if any picks reference these games. Remove all picks first.
                </p>
                <button
                    onClick={onResetGames}
                    disabled={!activeTournament}
                    className="bg-red-900 hover:bg-red-800 disabled:opacity-50 border border-red-700 text-red-300 font-bold px-6 py-2 rounded-lg transition-colors text-sm"
                >
                    Reset games
                </button>
            </div>

            <div className="bg-gray-900 border border-red-700 rounded-xl p-6">
                <h3 className="text-lg font-black text-red-400 mb-2">Delete entire tournament</h3>
                <p className="text-gray-400 text-sm mb-4">
                    Permanently deletes <strong className="text-white">{activeTournament?.name}</strong> and
                    everything associated with it — all pools, picks, games, rounds, seeds, and scoring rules.
                    This cannot be undone.
                </p>
                <button
                    onClick={onDeleteTournament}
                    disabled={!activeTournament}
                    className="bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-bold px-6 py-2 rounded-lg transition-colors text-sm"
                >
                    Delete tournament permanently
                </button>
            </div>
        </div>
    );
}

export default AdminDangerZone;